// src/redux/reducers/internal/internalReducer.js
import {
  FETCH_DISTRICTS_REQUEST,
  FETCH_DISTRICTS_SUCCESS,
  FETCH_DISTRICTS_FAILURE,
  FETCH_MUNICIPALITIES_REQUEST,
  FETCH_MUNICIPALITIES_SUCCESS,
  FETCH_MUNICIPALITIES_FAILURE,
  FETCH_WARDS_REQUEST,
  FETCH_WARDS_SUCCESS,
  FETCH_WARDS_FAILURE,
  CLEAR_MUNICIPALITIES,
  CLEAR_WARDS,
} from "../../actions/internal/internalActions";

const initialState = {
  districts: [],
  municipalities: [],
  wards: [],
  loading: false,
  error: null,
};

const internalReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DISTRICTS_REQUEST:
    case FETCH_MUNICIPALITIES_REQUEST:
    case FETCH_WARDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DISTRICTS_SUCCESS:
      return {
        ...state,
        loading: false,
        districts: action.payload,
        error: null,
      };

    case FETCH_MUNICIPALITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        municipalities: action.payload,
        error: null,
      };

    case FETCH_WARDS_SUCCESS:
      return {
        ...state,
        loading: false,
        wards: action.payload,
        error: null,
      };

    case CLEAR_MUNICIPALITIES:
      return {
        ...state,
        municipalities: [],
      };

    case CLEAR_WARDS:
      return {
        ...state,
        wards: [],
      };

    case FETCH_DISTRICTS_FAILURE:
    case FETCH_MUNICIPALITIES_FAILURE:
    case FETCH_WARDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default internalReducer;
